// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__24DSf","header":"ClearentDisclaimer_header__Q88Du","inner":"ClearentDisclaimer_inner__3Ysf9"};